module.exports = __webpack_public_path__ + "img/cover-1.6b6b368e.png";